import React, { useState } from 'react'
import { AGGridTable, Avatar, Button } from '../../../../../../components/common'
import headers from "./header.json"
import { useLazyQuery } from '@apollo/client'
import { DownloadIcon } from '../../../../../../theme/icons'
import { GET_USER_WISE_LIST } from '../../../../../../grapghQl/queries/freshDesk'
import moment from 'moment'
import { generateBGColorClassName } from '../../../../../../utils/randomColor'

export const UserWiseTable = ({ startDate }) => {
    const [params, setParams] = useState({})
    const [collectClientDatas] = useLazyQuery(GET_USER_WISE_LIST, { fetchPolicy: 'no-cache' });

    const fetchDataFromAPI = async (params) => {
        const filterModel = params.api.getFilterModel()
        try {
            const { data } = await collectClientDatas({
                variables: {
                    startRow: params.request.startRow,
                    endRow: params.request.endRow,
                    startDate: moment(startDate)?.startOf('month')?.format('YYYY-MM-DD'),
                    endDate: moment(startDate)?.endOf('month')?.format('YYYY-MM-DD'),
                    filterModel: filterModel
                }
            })
            const { greyTHRUsersTicketsCounts: { data: results = [], total = 0 } = {} } = data || { greyTHRUsersTicketsCounts: [] }
            if (filterModel?.search?.filter) {
                params?.successCallback(results, results?.length > 0 ? results?.length : 0);
            } else {
                params?.successCallback(results, total);
            }
            params?.api?.hideOverlay();
            !results?.length && params?.api?.showNoRowsOverlay();
        } catch (error) {
            params?.api?.hideOverlay();
            params.failCallback()
        }
    }

    const datasource = {
        async getRows(params) {
            setParams(params)
            fetchDataFromAPI({ ...params })
        }
    }

    const gridOptions = {
        pagination: false,
        serverSideFilterOnServer: true,
        serverSideDatasource: datasource,
        rowModelType: "serverSide",
        cacheBlockSize: 30,
        rowHeight: 64,
        paginationPageSize: 30,
        cacheOverflowSize: 2,
        maxConcurrentDatasourceRequests: 2,
        infiniteInitialRowCount: 1,
        maxBlocksInCache: 2
    };

    const handleDownload = () => {
        const fileName = `User wise freshdesk ticket list 
        ${moment(startDate)?.startOf('month')?.format('YYYY-MM-DD')}-${moment(startDate)?.endOf('month')?.format('YYYY-MM-DD')}`
        params?.api?.exportDataAsExcel({
            fileName: fileName?.replace(/ +/g, "_"),

        });
    }

    const cellRenderers = { 'user.name': UserName };

    const getDataHeaders = () => {
        const newheaders = [...headers] || []
        return newheaders.map(header => {
            header.cellRenderer = cellRenderers[header.field]
            return header;
        });
    }
    const handleSearchChange = (text) => {
        Object?.keys(params?.api)?.length &&
            params?.api?.setFilterModel({ search: { filterType: "text", type: "contains", filter: text } });
    }

    return (
        <div>
            <AGGridTable
                customComponentRight={<Button onClick={handleDownload}
                    iconPos="r"
                    variant="tertiary"
                    className="flex border border-secondary-200 items-center justify-end p-0 mr-0 bg-transparent"
                    icon={<DownloadIcon className="h-5 w-5 mr-2 mx-0 my-1.5" />} text={''} />}
                filterParams={{}}
                tableHeight="h-[25rem]"
                onChangeSearch={handleSearchChange}
                gridOptions={gridOptions}
                headers={getDataHeaders()}
                sidebar={false}
                placeholderText="Search"
                search={true} />
        </div>
    )
}

const UserName = (params) => {
    const { rowIndex = 0, data: { user: { name = "" } = {} } = {} } = params;
    return (<div className="flex flex-col h-full justify-center">
        <div className="flex gap-3">
            <div className="flex items-center">
                <Avatar alt={name} className={`${generateBGColorClassName(rowIndex)}`} type="text" />
            </div>
            <div className="flex flex-col truncate text-base font-normal justify-center text-secondary-500">
                <span className="ag-grid-heading-1 truncate capitalize" role='button'
                >{name}</span>
            </div>
        </div>
    </div>)

}
